import { gql } from '@apollo/client';

/** A day's meetings with tips written but not yet released (empty for a viewer who sees private meetings). */
export const GET_UNRELEASED_MEETINGS = gql`
  query GetUnreleasedMeetings($date: String!) {
    unreleasedMeetings(date: $date) {
      count
      tracks
    }
  }
`;
